import { render, staticRenderFns } from "./index.vue?vue&type=template&id=75f6deba&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75f6deba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('75f6deba')) {
      api.createRecord('75f6deba', component.options)
    } else {
      api.reload('75f6deba', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=75f6deba&scoped=true", function () {
      api.rerender('75f6deba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/packages/BjInputMoney/index.vue"
export default component.exports